module.exports = __webpack_public_path__ + "img/completed-graphic.e1a34b67.svg";